<template>
    <div>
        <div class="title__rank">
            <span v-html="t.earnings_forecast_title"></span>
            <span class="badge-forecast" v-text="t.new"></span>
            <span class="helper__tooltip white icon__title">
                <span class="helper__tooltip--text" v-html="t.earnings_forecast_tooltip"></span>
            </span>
            
        </div>
        <div class="earnings__forecast card-v4">
            <div>
                <div>
                    <h3>{{ t.earnings_forecast_value_label }} (BRL)</h3>
                    <div class="values">
                        <span>BRL</span>
                        <span v-text="values.commission_previous_BRL"></span>
                    </div>
                </div>
            </div>
            <div class="separator"></div>
            <div>
                <div>
                    <h3>{{ t.earnings_forecast_value_label }} (EUR)</h3>
                    <div class="values">
                        <span>EUR</span>
                        <span v-text="values.commission_previous_EUR"></span>
                    </div>
                </div>
            </div>
            <div class="separator"></div>
            <div>
                <div>
                    <h3>{{ t.earnings_forecast_value_label }} (USD)</h3>
                    <div class="values">
                        <span>USD</span>
                        <span v-text="values.commission_previous_USD"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import merge from 'lodash-es/merge';

export default {
    name: "earnings-forecast",
    components: {},
    data() {
        return {
            t: this.$parent.view.translation.earningsForecast,
            values: this.$parent.view.forecast_comissions
        };
    }
};
</script>
<style scoped lang="scss">
.title__rank {

    background: #7400fc;
    align-items: center;
    padding: 0.5rem 2.5rem;

    .badge-forecast {
        padding: 3px 12px;
        background: #fff;
        margin-left: 15px;
        border-radius: 37px;
        font-size: 0.9rem;
        font-weight: bold;
        color: #7400fc;
        font-weight: bold;
    }
}
.earnings__forecast {
    display: flex;
    @media only screen and (max-width: 992px) {
        flex-direction: column;
        div.separator {
            display: none;
        }
    }
    div {
        &.separator {
            border-left: 1px solid rgba(0, 0, 0, 0.12);
            padding: 1rem 0;
        }
        &:not(.separator) {
            flex: 1;
            div {
                width: 200px;
                margin: auto;
                text-align: center;
                padding: 0 0 0.6rem 0;
                h3 {
                    font-weight: 700;
                    font-size: 16px;
                    color: #7400fc;
                    text-transform: uppercase;
                    border-bottom: 1px solid #C6C6C6;
                    margin: 0 0 1.3rem 0;
                    padding: 10px 0;
                }
                div.values {
                    display: flex;
                    justify-content: space-between;
                    border-bottom: 0.5px solid rgba(0, 0, 0, 0.12);
                    span {
                        color: #7400fc;
                        font-weight: 700;
                        font-size: 1rem;
                        line-height: .9;
                    }
                }
            }
        }
    }
}
.helper__tooltip--text {
    width: 170px;
    top: 25px;
}
.helper__tooltip:after {
    top: -8px;
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/rank/components/earningsForecast.vue